import { Component } from 'react'
import PropTypes from 'prop-types'

import Link from 'components/link'

export default class DismissableModalButton extends Component {
  static propTypes = {
    dismissed: PropTypes.bool.isRequired,
    dismissText: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
      .isRequired,
    onSaveDismissed: PropTypes.func.isRequired,
  }

  state = {
    submitting: false,
  }

  render() {
    if (this.props.dismissed) {
      return null
    }

    return (
      <div className="text-center">
        {this.state.submitting ? (
          <span className="text-muted">
            <i className="fa fa-spinner fa-spin mls" /> Saving...
          </span>
        ) : (
          <Link onClick={this.handleSaveDismissed}>
            {this.props.dismissText}
            <i className="hide fa fa-spinner fa-spin mls" />
          </Link>
        )}
      </div>
    )
  }

  handleSaveDismissed = () => {
    this.setState({ submitting: true })
    this.props.onSaveDismissed()
  }
}
